export const _setPrisonCode = (state, action) => {
  state.prisonCode = action.payload;
};

export const _setPrisonNumber = (state, action) => {
  state.prisonNumber = action.payload;
};

export const _setInstitutionGender = (state, action) => {
  state.gender = action.payload;
};
